import { createAction } from "redux-act";

export const fetchHelpPages = createAction();
export const fetchHelpPagesSuccess = createAction<object>();
export const fetchHelpPagesFailed = createAction<Error>();
